import type { MouseEvent, KeyboardEvent } from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { EncounterSummary } from "../../../shared/types/encounter";

interface Props {
  encounter: EncounterSummary;
}

/**
 * Cột thao tác của "Lịch sử khám": một nút "Chi tiết" thấy ngay trên dòng.
 *
 * - Hành động chính của dòng là mở hồ sơ khám, và đã có sẵn khi bấm vào dòng — nên KHÔNG lặp lại
 *   nó thành một nút.
 * - "Chi tiết" mở chi tiết lượt đặt lịch (dịch vụ / phí khám / QR của lượt đặt). Lần khám mở tay
 *   (không gắn lịch hẹn) thì nút khoá kèm lý do — không dẫn tới một trang 404.
 * - KHÔNG có nút xoá trên dòng (quyết định 28/10/2026): xoá hồ sơ chưa ký đi qua chọn dòng +
 *   `BulkDeleteBar`; hồ sơ ĐÃ KÝ không xoá được ở mọi đường (#18725).
 *
 * Click trong cột được chặn tại wrapper để không nổi lên dòng (dòng điều hướng sang màn khám).
 */
export function EncounterRowActions({ encounter }: Props) {
  const stop = (ev: MouseEvent | KeyboardEvent) => ev.stopPropagation();

  return (
    <div className="flex items-center justify-end" onClick={stop} onKeyDown={stop}>
      {encounter.appointmentId ? (
        <Button asChild variant="outline" size="sm" className="h-8">
          <Link
            to={`/appointments/${encounter.appointmentId}`}
            data-testid="encounter-booking-detail"
          >
            <Info aria-hidden="true" />
            Chi tiết
          </Link>
        </Button>
      ) : (
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8"
          disabled
          title="Lần khám này không gắn với lịch hẹn nào"
        >
          <Info aria-hidden="true" />
          Chi tiết
        </Button>
      )}
    </div>
  );
}
